import { curry } from 'ramda';

export function initAccessDataStorage() {
  return {
    setData(access) {
      localStorage.setItem('access', JSON.stringify(access));
    },
    getData() {
      return JSON.parse(localStorage.getItem('access') || '{}');
    },
  };
}

export function makeAccessData({ isFreeEvent = false, wasPaid = false } = {}) {
  return {
    isFreeEvent,
    wasPaid,
  };
}

export function hasFullAccess(access) {
  return access.isFreeEvent || access.wasPaid;
}

export function isEnabledWatermarkBySrc(src) {
  const labelWM = 'nwm845';
  return !src.includes(labelWM);
}

export const isAvailableToUsePhoto = curry(
  (access, photo) =>
    // console.log('isAvailableToUsePhoto', hasFullAccess(access) || !isEnabledWatermarkBySrc(photo.full_path), hasFullAccess(access), !isEnabledWatermarkBySrc(photo.full_path));
    hasFullAccess(access) || !isEnabledWatermarkBySrc(photo.full_path)
);

export function getWatermarkSrc(access, photo, watermarkSrc = null) {
  if (!isAvailableToUsePhoto(access, photo)) return watermarkSrc;
  return null;
}

export function initWatermarkStorage() {
  return {
    setSrc(src) {
      localStorage.setItem('watermarkSrc', src);
    },
    getSrc() {
      return localStorage.getItem('watermarkSrc');
    },
  };
}
